import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';

const menuler = [
  { path: '/bekleme', icon: '⏳', label: 'Bekleme Odası' },
  { path: '/hasta-ara', icon: '🔍', label: 'Hasta Ara' },
  // Sadece personelin kullanıcı adı/şifre ile girdiği (giristipi='normal') oturumlarda görünür —
  // hasta linki veya personel link (token) girişlerinde hiç listelenmez (kullanıcı talebi: 2026-08-08).
  { path: '/kabul', icon: '📋', label: 'Kabul İşlemleri', sadeceNormalGiris: true },
  { path: '/fiyat-ver', icon: '💰', label: 'Fiyat Ver', sadeceNormalGiris: true },
];

export default function Layout() {
  const [sidebarAcik, setSidebarAcik] = useState(false);
  const navigate = useNavigate();
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const giristipi = localStorage.getItem('giristipi');
  const tokenGiris = giristipi === 'token';
  const normalGiris = giristipi === 'normal';
  const gorunurMenuler = menuler.filter(m => !m.sadeceNormalGiris || normalGiris);

  const cikisYap = () => {
    localStorage.removeItem('kullanici');
    localStorage.removeItem('giristipi');
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Sidebar */}
      <div style={{
        width: sidebarAcik ? '220px' : '60px',
        background: 'var(--med-dark)',
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.2s',
        flexShrink: 0,
        overflow: 'hidden',
      }}>
        {/* Logo */}
        <div style={{ padding: '16px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 20 }}>🏥</span>
          {sidebarAcik && (
            <div>
              <div style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>Dr. Plazma</div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 10 }}>Medikal Yazılımları</div>
            </div>
          )}
        </div>

        {/* Kullanıcı */}
        {sidebarAcik && (
          <div style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'var(--med-accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 12, fontWeight: 600, flexShrink: 0 }}>
              {kullanici.adSoyad?.charAt(0) || 'K'}
            </div>
            <div style={{ overflow: 'hidden' }}>
              <div style={{ color: '#fff', fontSize: 12, fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{kullanici.adSoyad || 'Kullanıcı'}</div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 10 }}>Doktor</div>
            </div>
          </div>
        )}

        {/* Menü */}
        <nav style={{ flex: 1, padding: '8px 0' }}>
        {tokenGiris && <div style={{ padding: '8px 16px', fontSize: 11, color: 'rgba(255,255,255,0.3)', fontStyle: 'italic' }}>Sınırlı erişim</div>}
          {sidebarAcik && <div style={{ padding: '8px 16px 4px', fontSize: 10, color: 'rgba(255,255,255,0.3)', letterSpacing: '1px', textTransform: 'uppercase' }}>Ana Menü</div>}
          {!tokenGiris && gorunurMenuler.map(m => (
            <NavLink key={m.path} to={m.path} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10,
              padding: sidebarAcik ? '9px 16px' : '9px 18px',
              color: isActive ? '#5DCAA5' : 'rgba(255,255,255,0.55)',
              textDecoration: 'none', fontSize: 13,
              background: isActive ? 'rgba(29,158,117,0.2)' : 'transparent',
              borderRight: isActive ? '2px solid #1D9E75' : '2px solid transparent',
              transition: 'all 0.1s',
            })}>
              <span style={{ fontSize: 16, flexShrink: 0 }}>{m.icon}</span>
              {sidebarAcik && m.label}
            </NavLink>
          ))}
        </nav>

        {/* Çıkış */}
        <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <button onClick={cikisYap} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>🚪</span>{sidebarAcik && 'Çıkış Yap'}
          </button>
        </div>
      </div>

      {/* İçerik */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {/* Üst bar */}
        <div style={{ height: 'var(--header-h)', background: '#fff', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', padding: '0 20px', gap: 12, flexShrink: 0 }}>
          <button onClick={() => setSidebarAcik(!sidebarAcik)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: 'var(--text-muted)' }}>☰</button>
          <span style={{ fontSize: 13, fontWeight: 500 }}>Dr. Plazma Evde Bakım Merkezi Yazılımı</span>
        </div>

        {/* Sayfa içeriği */}
        <div style={{ flex: 1, overflow: 'auto', padding: 20 }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
